/**
 * React inspired prioritization. Ideally we will be able to integrate directly
 * with React in the future once Concurrent Stores lands.
 *
 * https://react.dev/blog/2025/04/23/react-labs-view-transitions-activity-and-more#concurrent-stores
 */
export const NoLane = /*  */ 0b0000000000000000000000000000000;
export const SyncLane = /**/ 0b0000000000000000000000000000001;

export type Lane = typeof NoLane | typeof SyncLane;
